var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie-wrapper"},[_c('span',{staticClass:"label"},[_vm._t("default")],2),_c('div',{staticClass:"pie",style:(_vm.pie)},[_c('div',{class:['half-circle'],style:(_vm.leftSide)}),_c('div',{class:['half-circle'],style:(_vm.rightSide)})]),_c('div',{staticClass:"shadow"})])
}
var staticRenderFns = []

export { render, staticRenderFns }